import { useAuth } from '../contexts/AuthContext';

export default function DashboardPage() {
  const { user, signOut } = useAuth();

  return (
    <div style={{ padding: '20px' }}>
      <h1>Dashboard</h1>
      <p>Welcome, {user?.email}</p>
      <button onClick={signOut} style={{ marginTop: '20px', padding: '10px', cursor: 'pointer' }}>
        Sign Out
      </button>
    </div>
  );
}
